import React from "react";
import type { School } from "../types/team";
interface NameRosterProps {
  school: School;
  title: string;
  country: string;
  names: string[];
  duplicates: Set<string>;
  onChange: (index: number, value: string) => void;
}
export function NameRoster({
  school,
  title,
  country,
  names,
  duplicates,
  onChange
}: NameRosterProps) {
  const dot = school === "link" ? "bg-brgreen" : "bg-saffron";
  const filled = names.filter(n => n.trim()).length;
  return <section aria-labelledby={`${school}-heading`} data-id="element-179" data-mp="2oeokkveus075">
      <div className="flex items-baseline justify-between gap-3 pb-3" data-id="element-180" data-mp="2jl2ejm372ukb">
        <div className="flex items-center gap-2.5 min-w-0" data-id="element-181" data-mp="2emiszmsijksh">
          <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${dot}`} aria-hidden="true" data-id="element-182" data-mp="2ekxytya423v5" />
          <h2 id={`${school}-heading`} className="truncate text-[15px] font-semibold" data-id="element-183" data-mp="2an9y2elqlgvc">
            {title}
          </h2>
          <span className="shrink-0 text-sm text-muted" data-id="element-184" data-mp="25o6wj44ytss4">{country}</span>
        </div>
        <span className="shrink-0 text-sm tabular-nums text-muted" data-id="element-185" data-mp="20pcbdvjizs4u">
          {filled}/{names.length}
        </span>
      </div>

      <ol className="divide-y divide-line overflow-hidden rounded-xl border border-line bg-surface" data-id="element-186" data-mp="pmf9cfzf9464">
        {names.map((name, index) => {
        const isDuplicate = duplicates.has(name.trim().toLowerCase());
        const isEmpty = !name.trim();
        return <li key={index} className="flex items-center gap-3 px-3.5" data-id="element-187" data-mp="grzhcitvstt1" data-mpi={index}>
              <span className="w-4 text-right text-xs tabular-nums text-muted" aria-hidden="true" data-id="element-188" data-mp="14kfy8q1vufqr">
                {index + 1}
              </span>
              <label className="sr-only" htmlFor={`${school}-${index}`} data-id="element-189" data-mp="um0i1i4e8qw1">
                {title} participant {index + 1}
              </label>
              <input id={`${school}-${index}`} value={name} onChange={e => onChange(index, e.target.value)} placeholder="Enter name" aria-invalid={isDuplicate || isEmpty} className="min-w-0 flex-1 bg-transparent py-2.5 text-[15px] outline-none placeholder:text-muted/60 focus-visible:underline focus-visible:decoration-line focus-visible:underline-offset-4" data-id="element-190" data-mp="zjjzss0avlsq" />
              {isDuplicate && <span className="shrink-0 text-xs font-medium text-danger" data-id="element-191" data-mp="2rfmb0a7vi8oy">Duplicate</span>}
            </li>;
      })}
      </ol>
    </section>;
}